module.exports = __webpack_public_path__ + "img/icon_add_w.08a8720f.svg";